<template>
  <div>
    <edit-account-prop-dialog :current-details="selectedDetails" :show-modal="selectedDetails != null"
                              @close="closeModal()"/>
    <table class="striped_table w-100">
      <tr v-for="(row) in tableData"
          :key="row.id">
        <td class="w-25">{{ $t('accountProps.knownPropTypes.' + row.type) }}</td>
        <td>{{ row.value }}</td>
        <td style="min-width: 5rem" class="float-right">
          <base-button icon round simple size="sm" type="info" class="m-0 d-inline-block" @click.native="edit(row)"
                       v-if="$auth.can({account_props: 'update'}, 'permissions')">
            <i class="tim-icons icon-pencil"/>
          </base-button>
          <base-button size="sm" simple icon round type="danger" @click.native="deleteAccountProperty(row)"
                       class="d-inline-block"
                       v-if="$auth.can({account_props: 'delete'}, 'permissions')">
            <i class="tim-icons icon-simple-remove"/>
          </base-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import swal from "sweetalert2";
import EditAccountPropDialog from './EditAccountPropDialog'

export default {
  name: 'accountPropsView',
  components: {
    EditAccountPropDialog
  },
  props: {
    accountProps: {
      type: Array,
      required: true,
    },
    fullShow: {
      type: Boolean,
      required: false,
    },
    showN: {
      type: Number,
      required: false,
      default: 2
    },
  },
  data() {
    return {
      selectedDetails: null
    }
  },
  computed: {
    tableData() {
      if (this.fullShow) {
        return this.accountProps
      }

      const result = this.accountProps;
      result.sort((a, b) => {
        let typeA = 0
        switch (a.type) {
          case 'owner':
            typeA = 1;
            break
        }

        let typeB = 0
        switch (b.type) {
          case 'owner':
            typeB = 1;
            break

        }

        if (typeA > typeB) {
          return -1;
        }
        if (typeA < typeB) {
          return 1;
        }

        return 0;
      })

      if (result.length > this.showN) {
        return result.slice(0, this.showN);
      }

      return result
    }

  },
  methods: {
    ...mapActions(['DeleteAccountProps', 'LoadAccountProps']),
    edit(row) {
      this.selectedDetails = row
    },
    closeModal() {
      this.selectedDetails = null
    },
    deleteAccountProperty(row) {
      swal({
        title: this.$t('accountProps.delete.text'),
        text: '\'' + this.$t('accountProps.knownPropTypes.' + row.type) + '\': \'' + row.value + '\'',
        confirmButtonText: this.$t('accountProps.delete.actionBtnLabel'),
        cancelButtonText: this.$t('accountProps.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeleteAccountProps({accountId: row.account_id, id: row.id}).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('accountProps.delete.successNotification'),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.LoadAccountProps(row.account_id)
            }
          })
        }
      });
    }
  },
  // watch: {
  //   fullShow() {
  //     console.log("fullShow change")
  //   }
  // }
};
</script>
